<ll-titulo>Cuentas Usuarios</ll-titulo>
<ll-toolnavbar>
    <cuentas-admin-toolnavbar [displayButtons]="'new,search'"></cuentas-admin-toolnavbar>
</ll-toolnavbar>

<cuentas-admin [showButtonDelete]="true"></cuentas-admin>
